import axios from 'axios'
export default {

  async adminAll (
    businesId,
    startDate,
    endDate,
    terminal) {
    try {
      const response = await axios.get(
        'dashboard/adminAll?business=' + businesId +
        '&startDate=' + startDate +
        '&endDate=' + endDate +
        '&pos=' + terminal)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async adminDay (
    businesId,
    startDate,
    endDate,
    terminal) {
    try {
      const response = await axios.get(
        'dashboard/adminDays?business=' + businesId +
        '&startDate=' + startDate +
        '&endDate=' + endDate +
        '&pos=' + terminal)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async adminYear (
    businesId,
    terminal) {
    try {
      const response = await axios.get(
        'dashboard/adminYear?business=' + businesId +
        '&pos=' + terminal)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async adminMonth (
    businesId,
    startDate,
    endDate,
    terminal) {
    try {
      const response = await axios.get(
        'dashboard/adminMonth?business=' + businesId +
        '&startDate=' + startDate +
        '&endDate=' + endDate +
        '&pos=' + terminal)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  }

}
